import JImageList from './JImageList'

/* istanbul ignore next */
JImageList.install = function (Vue) {
  Vue.component(JImageList.name, JImageList)
}

export default JImageList
